import axios from "axios";

const authRequest = axios.create({
    baseURL: "/api",
    // baseURL: "https://www.warmwarm.tw/api/",
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*", // Add this line to allow all origins (adjust as needed)
    },
    withCredentials: true, // Ensure this is set if you are using credentials
});

// Add a request interceptor
authRequest.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
authRequest.interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    }
);

//線上捐糧
export const postEcpayFood = (body) => authRequest.post("/ecpay/food/", body);

//物資捐贈
export const postEcpayMaterial = (body) =>
    authRequest.post("/ecpay/material/", body);

//線上購物
export const postEcpayShop = (body) => authRequest.post("/ecpay/shop/", body);
